import React from "react";
import { Compass } from "lucide-react";
import { CareerJourneyTimeline } from "./CareerJourneyTimeline";

/** Section 3 — How Cloudivo Works: interactive full career journey timeline. */
export const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="max-w-6xl mx-auto px-6 py-16" data-testid="how-it-works-section">
      <div className="max-w-2xl mb-12">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-400 flex items-center gap-2">
          <Compass className="w-3.5 h-3.5" /> How Cloudivo Works
        </span>
        <h2 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight mt-3">One path, start to hired.</h2>
        <p className="text-slate-400 mt-3">Click any step below to see how it fits into your journey.</p>
      </div>
      <CareerJourneyTimeline variant="full" />
    </section>
  );
};
